<template>
  <div class="back-color">
    <div :style="fistContenairStyle">
      <NavHeader :title="config.mainTitle" :listItem="items" />
      <b-container class="first-container-top ">
        <b-row>
          <b-col cols="12" sm="12" md="12" lg="12" xl="12">
            <h2 class="video-title wow fadeIn" data-wow-duration="2s" data-wow-delay="1s">{{ mata_title}}</h2>
            <iframe
              allowfullscreen
              :src="`https://www.youtube.com/embed/${id}?rel=0`"
              frameborder="0"
              class="wow fadeIn embed"
              data-wow-duration="2s" data-wow-delay="3s"
            />
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="first-container">
      <b-container class="container-iframe">
        <b-row>
          <b-col cols="12" sm="12" md="12" lg="12" xl="12">
            <div class="mt-3 social-share text-right ">
              <span class="wow fadeIn" data-wow-duration="2s" > {{ $t('page_video.action_partager') }}  </span>
              <a
                :href="facebookUrl"
                @click.prevent="ShareFb"
                target="_blank"
                aria-label="Facebook"
                title="Facebook"
                class="wow fadeIn"
                data-wow-duration="2s" data-wow-delay="2s"
              >
                <span class="fa fa-facebook ml-2"></span>
              </a>
              <a
                :ref="twitterUrl"
                @click.prevent="ShareTwitter"
                target="_blank"
                aria-label="Twitter"
                title="Twitter"
                class="wow fadeIn"
                data-wow-duration="2s" data-wow-delay="3s"
              >
                <span class="fa fa-twitter ml-3"></span>
              </a>
            </div>
            <h3 class="wow fadeIn"
                data-wow-duration="2s" > {{ $t('page_video.bonus' ) }} </h3>
            <p class="wow fadeIn p-description"
                data-wow-duration="2s" data-wow-delay="1s" v-html="$t('page_video.videos.' + id + '.bonus')"></p>
            <hr />
          </b-col>
        </b-row>
      </b-container>
    </div>
    <b-container>
      <b-row v-if="isLoading">
        <b-col cols="12" class="align-items-center mb-4 text-center">
          <b-spinner class="ml-auto spiner-color"></b-spinner>
        </b-col>
      </b-row>
      <b-row v-if="!isLoading">
        <b-col cols="12" class="all-video-title text-center">
          <h2> {{ $t('page_video.section_videos.titre' ) }} </h2>
        </b-col>
        <b-col
          cols="12"
          sm="4"
          md="4"
          lg="3"
          xl="3"
          class="mb-4"
          v-for="item in items"
          :key="item.id"
        >
          <VideoCard :item="item" @click="onClick" :currentItem="currentItem" />
        </b-col>
      </b-row>
    </b-container>
    <Footer :footerImage="itemData.footerImage" />
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import { config } from '../config.js'
import Footer from '../components/Footer'
import VideoCard from '../components/VideoCard'
import NavHeader from '../components/NavHeader'
export default {
  props: ['id'],
  components: { VideoCard, Footer, NavHeader },
  data () {
    return {
      isLoading: true,
      playListItems: {},
      playerVars: {
        enablejsapi: 0
      },
      publicPath: process.env.BASE_URL,
      itemData: {},
      imageFooter: {}
    }
  },
  mounted () {
    this.FetchVideoData(this.id)
    window.scroll({ top: 0, left: 0, behavior: 'smooth' })
    this.itemData = this.getItemData(this.id)
    if (!this.itemData) {
      this.itemData = {}
    }
  },
  watch: {
    locale () {
      this.fetchData(true)
    }
  },
  computed: {
    ...mapGetters(['getItem', 'getItemData']),
    currentUrl () {
      return encodeURI(location.href)
    },
    facebookUrl () {
      return `http://www.facebook.com/dialog/share?app_id=87741124305&href=https%3A//www.youtube.com/watch%3Fv%3D${this.id}&display=popup&redirect_uri=https%3A//www.youtube.com/watch%3Fv%3D${this.id}`
    },
    twitterUrl () {
      return `https://twitter.com/intent/tweet?url=https%3A//youtu.be/${
        this.id
      }&text=${
        this.getItem && this.getItem.snippet ? this.getItem.snippet.title : ''
      }&via=YouTube&related=YouTube,YouTubeTrends,YTCreators`
    },
    config () {
      return config
    },
    mata_title () {
      return this.getItem && this.getItem.snippet
        ? this.getItem.snippet.title
        : ''
    },
    meta_description () {
      return this.getItem && this.getItem.snippet
        ? this.getItem.snippet.description
        : ''
    },
    meta_statistics () {
      return this.getItem && this.getItem.statistics
        ? this.getItem.statistics
        : ''
    },
    items () {
      if (this.playListItems && this.playListItems.items) {
        return this.playListItems.items.filter(item => {
          return item.snippet.position !== 0
        })
      }
      return null
    },
    currentItem () {
      if (this.playListItems && this.playListItems.items) {
        return this.playListItems.items.find(item => {
          return item.snippet.resourceId.videoId === this.id
        })
      }
      return null
    },
    fistContenairStyle () {
      return {
        // "background-size": "37% 12%",
        // "background-repeat": "no-repeat",
        // "background-position": "right top",
        'background-size': 'cover',
        'background-image': `url(${this.publicPath}fond_1.jpg)`
      }
    },
    locale () {
      return this.$i18n.locale
    }
  },
  metaInfo () {
    return {
      title: `${this.mata_title} | Energie-environement.ch`,
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: this.meta_description
        },
        {
          property: 'og:title',
          content: this.mata_title
        },
        {
          property: 'og:description',
          content: this.meta_description
        },
        {
          property: 'og:type',
          content: 'website'
        },
        {
          property: 'og:image',
          content: this.currentItem && this.currentItem.snippet && this.currentItem.snippet.thumbnails && this.currentItem.snippet.thumbnails.standard
            ? this.currentItem.snippet.thumbnails.standard.url
            : ''
        },
        {
          property: 'og:url',
          content: this.currentUrl
        }
      ]
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    ...mapMutations(['SET_ITEM']),
    FetchVideoData (videoId) {
      this.$Progress.start()
      this.$http({
        method: 'get',
        url: 'videos',
        crossDomain: true,
        params: {
          key: config.apiKey,
          part: `${config.part.snippet},${config.part.statistics}`,
          id: videoId,
          fields: config.videoFields,
          playlistId: config.playlistIds[this.$i18n.locale]
        }
      })
        .then(response => {
          this.SET_ITEM(response.data.items[0])
        })
        .catch(response => {
          console.log(response)
          this.$Progress.fail()
        })
        .finally(() => {})
    },
    fetchData (fetchVideoFromCurrentPosition = false) {
      this.isLoading = true
      this.$http({
        method: 'get',
        url: 'playlistItems',
        crossDomain: true,
        params: {
          key: config.apiKey,
          part: config.part.snippet,
          fields: config.playListFields,
          playlistId: config.playlistIds[this.$i18n.locale],
          maxResults: config.maxResults
        }
      })
        .then(response => {
          this.playListItems = response.data
          this.playListItems.items.forEach(element => {
            this.$set(element, 'isOver', false)
          })

          if (fetchVideoFromCurrentPosition) {
            const currentItemInTargetLang = this.playListItems.items.find(item => item.snippet.position === this.getItem.snippet.position)
            this.onClick(currentItemInTargetLang)
          } else {
            const currentItem = this.playListItems.items.find(item => item.snippet.resourceId.videoId === this.getItem.id)
            if (currentItem) {
              const currentItemWithAdditionalData = { ...this.getItem }
              currentItemWithAdditionalData.snippet.position = currentItem.snippet.position
              this.SET_ITEM(currentItemWithAdditionalData)
            }
          }
          this.$Progress.finish()
        })
        .catch(response => {
          console.log(response)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    onClick (item) {
      if (this.currentItem && this.currentItem.id === item.id) {
        window.scroll({ top: 0, left: 0, behavior: 'smooth' })
        return
      }
      this.SET_ITEM(item)
      this.$Progress.start()
      window.scroll({ top: 0, left: 0, behavior: 'smooth' })
      let slug = item.snippet.title
      slug = slug.toLowerCase().replace(/ |’|'/g, '-').replace(/à/g, 'a')
      this.$router.push({
        name: 'video',
        params: {
          id: item.snippet.resourceId.videoId,
          slug: slug
        }
      })
      this.itemData = this.getItemData(item.snippet.resourceId.videoId)
      if (!this.itemData) {
        this.itemData = {}
      }
    },
    ShareFb () {
      open(this.facebookUrl, 'Facebook', 'width=600,height=400')
    },
    ShareTwitter () {
      open(this.twitterUrl, 'Twitter', 'width=600,height=400')
    }
  }
}
</script>

<style  scoped lang="scss">
@import "./src/styles/mainStyle.scss";
.embed {
  aspect-ratio: 16 / 9;
  width: 100%;
  height: auto;
  display: block;
}
.first-container {
  .play-logo {
    width: 100px;
    height: 100px;
  }
  p {
    color: white;
    font-size: 1.6em;
    margin-top: 10px;
    a {
      color: $linkColor !important;
    }
    @include family-zilla;
  }
  hr {
    background: gray;
  }
}
.all-video-title {
  font-size: 2em;
  color: $titleColor;
  margin-top: 0px;
  margin-bottom: 15px;
  @include family-zilla;
}
.container-iframe {
  h3 {
    color: $titleColor;
    font-size: 2.8em;
    @include family-zilla;
  }
}
.first-container-top {
  padding-top: 30px;
  padding-bottom: 0px;
}
.social-share {
  display: flex;
  align-items: center;
  gap: 18px;
  a {
    font-size: 1.2em;
    cursor: pointer;
  }
  span {
    color: white;
    font-size: 1.2em;
  }
  span:hover{
    color:#fefade;
  }
}
.video-title {
  color: $titleColor;
  font-size: 2.5em;
  @include family-zilla;
}
</style>
